var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ad"},[_c('div',{staticClass:"banner",on:{"click":_vm.linkTo}},[_c('img',{attrs:{"src":_vm.data.imgUrl,"alt":""}})])])}
var staticRenderFns = []

export { render, staticRenderFns }